module.exports = __webpack_public_path__ + "static/media/device.e4c1bde8.svg";